var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQrcode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 45.8333H45.8333V12.5H12.5V45.8333ZM20.8333 20.8333H37.5V37.5H20.8333V20.8333ZM12.5 87.5H45.8333V54.1667H12.5V87.5ZM20.8333 62.5H37.5V79.1667H20.8333V62.5ZM54.1667 12.5V45.8333H87.5V12.5H54.1667ZM79.1667 37.5H62.5V20.8333H79.1667V37.5ZM54.2083 54.1667H62.5417V62.5H54.2083V54.1667ZM62.5417 62.5H70.875V70.8333H62.5417V62.5ZM54.2083 70.8333H62.5417V79.1667H54.2083V70.8333ZM70.875 70.8333H79.2083V79.1667H70.875V70.8333ZM79.2083 79.1667H87.5417V87.5H79.2083V79.1667ZM62.5417 79.1667H70.875V87.5H62.5417V79.1667ZM70.875 54.1667H79.2083V62.5H70.875V54.1667ZM79.2083 62.5H87.5417V70.8333H79.2083V62.5Z",
    fill: "#F4F4F4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrcode);
export default __webpack_public_path__ + "static/media/qrcode.34b12538ef7dc02040fcbd1c8100e29d.svg";
export { ForwardRef as ReactComponent };